<template>
  <div class="f-col ctr site-list">
    <div class="f-col full site-list-wrapper">
      <div class="f-row list-header">
        <Icon class icon="fire" />
        <span>Lista de sites</span>
      </div>
      <SiteItem
        class="f-row ctr site-card"
        v-for="site in sites"
        :key="site.id"
        :site="site"
      />
    </div>
  </div>
</template>

<script>
import SiteItem from "./SiteItem";

export default {
  name: "SiteList",
  components: {
    SiteItem,
  },
  computed: {
    sites() {
      return this.$store.state.editor.sites;
    },
  },
};
</script>

<style scoped>
.site-list {
  width: fit-content;
  margin: 0 auto;
  padding-bottom: 2px;
  border: 1px solid #ccc;
  color: #555;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
  line-height: 1;
}

.site-list-wrapper {
  border-radius: 0.25rem;
  overflow: hidden;
}

.list-header {
  padding: 10px 0;
  margin-bottom: 2px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  color: #fbfbfb;
  background: #3e4e5e;
}

.list-header > svg {
  margin-left: 12px;
}
.list-header > span {
  margin: 0 8px;
}
</style>